import { createReducer } from 'redux-create-reducer'
const initialState = {
  byShortlistId: {} as object,
  byPlaylistId: {} as object,
}
export type AliasMetadataState = typeof initialState
export const aliasMetadataReducer = createReducer<AliasMetadataState, any>(
  initialState,
  {},
)
